var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/global.svg#card';
                    var viewUrl = 'svg/global.svg#view-card';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 24 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };